export default [
  {
    title: "공동분야",
    list: [
      {
        title: "공통분야",
        content: "1. 이력카드의 구비 및 기록여부(소방계획서)",
        isChecked: "",
      },
      {
        title: "공통분야",
        content: "2. 안전관리자 선임여부 및 부재시 대응방안 수립 여부",
        isChecked: "",
      },
      {
        title: "공통분야",
        content: "3. 긴급재난시 대피지침 수립여부",
        isChecked: "",
      },
      {
        title: "공통분야",
        content: "4. 비상연락망 구비여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "건축분야",
    list: [
      {
        title: "주요시설",
        content: "1. 보의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "2. 기둥(내력벽 등)의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "3. 슬래브(바닥판)의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "4. 주계단의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "5. 벽체의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "6. 지반 침하 및 이로 인한 활동적인 균열",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "7. 누수, 부식 등에 의한 구조물의 기능 상실",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "8. 주요강재의 변형 및 접합부 상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "9. 지붕(옥상)의 균열 및 상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "10. 계단실(복도)의 균열 및 상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "11. 외벽타일 또는 석재의 균열 및 탈락상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "12. 시설 외부 또는 내부의 과하중(물탱크 등) 여부",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "13. 강재의 도장 및 관리상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 일반",
        content: "14. 옹벽, 석축 및 담장의 균열 및 상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 일반",
        content: "15. 마감재(광고판 등)의 돌출 및 위험요소(충돌, 안전사고) 여부",
        isChecked: "",
      },
      {
        title: "부대시설 - 일반",
        content: "16. 상 하수도주변 시설 파손 및 누수",
        isChecked: "",
      },
      {
        title: "부대시설 - 공사장",
        content: "17. 대형건설기계(타워크레인 등) 안전성 및 관리상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 공사장",
        content: "18. 안전망 등의 설치여부 및 상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 공사장",
        content: "19. 공사용 안전 가시설 등의 설치여부 및 상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "전기분야",
    list: [
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "1. 규격 전선의 사용 여부",
        isChecked: "",
      },
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "2. 전선 접속 상태",
        isChecked: "",
      },
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "3. 전선 피복의 손상 여부",
        isChecked: "",
      },
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "4. 배선공사 방법의 적합 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "5. 규격전선의 사용 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "6. 전선 피복의 손상 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "7. 배선공사 방법의 적합 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "8. 비닐 코드선 사용 및 문어발 배선 사용 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "9. 보행로 전선 노출여부",
        isChecked: "",
      },
      {
        title: "누전차단기",
        content: "10. 누전차단기 적정 설치 및 정상 작동 여부",
        isChecked: "",
      },
      {
        title: "누전차단기",
        content: "11. 열화 및 손상 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "12. 개폐기의 적정설치 및 설치위치의 적합 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "13. 개폐기의 열화 및 손상 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "14. 정격퓨즈의 사용 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "15. 개폐기의 결선 상태",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "16. 다선식 선로의 각극 개폐장치 여부",
        isChecked: "",
      },
      {
        title: "비상전원설비",
        content: "17. 정전시 비상전원확보(비상발전기, UPS) 및 정상운전 여부",
        isChecked: "",
      },
      {
        title: "배 전 반",
        content: "18. 배전함 커버손상 및 사용하지 않는 콘센트의 밀봉여부",
        isChecked: "",
      },
      {
        title: "부하설비",
        content: "19. 전기기계기구 금속제 외함 접지 및 접지용 콘센트 사용여부",
        isChecked: "",
      },
      {
        title: "조명시설",
        content: "20. 조명탑 등 전기시설물 유지관리상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "기계분야",
    list: [
      {
        title: "시설영역",
        content: "1. 배관의 파손･누수･누기 및 유지관리 상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "2. 보일러, 공조시설 및 설비배관 부식 여부",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "3. 보일러, 공조시설 환기상태 및 배출기 작동여부",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "4. 기계실 모든 자재의 정리 정돈 상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "5. 지하설비 누수 상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "6. 급수･급탕･공조시설 관리 및 안전성",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "7. 오･폐수처리시설 가동상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "8. 기계식주차시설･주차타워 등의 안전관리 실태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "9. 화재 등 비상시 승강기의 비상운전 작동상태 여부",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "10. 승강기 내･외부 안전표지 부착 확인 등",
        isChecked: "",
      },
    ],
  },
  {
    title: "가스분야",
    list: [
      {
        title: "현장안전관리 상태검사",
        content: "1. 가스누출 여부(비누방울 시험법)",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "2. 가스누출 경보기 정상 작동여부",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "3. 중간밸브와 자동차단장치 정상 작동여부",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "4. 노출배관 및 부속물 유지관리 상태",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "5. 철거된 가스시설의 배관 또는 호스 끝 마감 처리 여부",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "6. 호스 T 사용 여부 및 호스 3m 이상 사용여부",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "7. 저장용기 보관실 설치여부 및 위험물표시(100kg 이하는 차양조치)",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "8. 보일러실에 보일러 이외의 적치물 보관여부",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "9. 가스보일러가 전용 보일러실에 설치 되었는지 여부",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "10. 가스저장탱크 안전거리 유지여부(화기와의 거리 유지)",
        isChecked: "",
      },
    ],
  },
  {
    title: "사면(급경사지)분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    footer: "※ 기초 세굴·부등침하 및 주요 구조부의 균열 등 <b>중대 결함</b>이 <b>발견</b> 된 경우 <b>민간전문가</b> 및 <b>점검장비</b>를 활용하여 <b>확인점검</b> 실시",
    list: [
      {
        title: "경사면내는 안전한가?",
        content: "- 균열 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 융기(배부름) 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 수목 전도 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 낙석 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 뜬 돌 존재 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 하단부 침식 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 지하수 유출 및 탁수의 용출 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 사면 붕괴 이력 및 규모, 위치는 관리하여야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 균열 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 융기(배부름) 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 낙석 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 사면 종・횡단배수로가 설치되어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 사면 종・횡단배수로 막힘이 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 평면상 높낮이 차(단차) 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 모르터 표면 습윤 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 배수공 막힘 등 배수기능 저하 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 보호․보강 구조물 파손발생 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 소규모 낙석, 붕괴에 의한 보호․보강 효과 저하 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "옹벽 분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 균열이 발생하지 않아야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 이음부 이격 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 전면부 배부름(돌출) 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 주변부 탁한 용수유출 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 낙석 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 단차, 전도 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 배수구 막힘이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 지반의 균열 및 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 배수로의 기능저하 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 옹벽 인접 교목 식생(2m이내) 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 콘크리트 파손 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 지반융기가 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 옹벽 침하가 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 주변부 탁한 용수유출이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 세굴의 발생이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 기초부 지반활동으로 인한 기울어짐이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
];
